import { TranslatePipe } from '@myre/ui-primitive-core';
import { TooltipDirective } from '@myre/ui-primitive-tooltip-directive';

import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'myre-icon-tooltip',
  templateUrl: './myre-icon-tooltip.component.html',
  styleUrls: ['./myre-icon-tooltip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TooltipDirective, TranslatePipe],
})
export class MyreIconTooltipComponent {
  @Input()
  public label: string;

  @Input()
  public icon: string;
}
